/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    holdings: `/holdings`,
};

/**
 * Experience API 업무구분 URL
 * @type {string}
 */
const sectors = {
    holdings: {
        banca: `${packages.holdings}/banca`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    holdings: {
        banca: {
            inquiry: `${sectors.holdings.banca}/inquiry`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    holdings: {
        banca: {
            inquiry: {
                getAccountDetail: `${details.holdings.banca.inquiry}/getAccountDetail`, // 계약기본사항
                listAccountTransaction: `${details.holdings.banca.inquiry}/listAccountTransaction`, // 납입내역
                getAccountServiceInfo: `${details.holdings.banca.inquiry}/getAccountServiceInfo`, // 해약환급금, 약관대출가능금액
                listAccountRateOfReturn: `${details.holdings.banca.inquiry}/listAccountRateOfReturn`, // 수익률조회, 펀드변경내역 상세조회
            },
        },
    },
};
